angular.module('rjmNg.directives').directive "connectionDetailItem", [
  () ->
    restrict: "E"
    templateUrl: "directive.connectionDetailItem.html"
    replace: true
    scope:
      connection: "="
    controllerAs: "view"
    bindToController: true
    controller: [
      () ->

        view = @
    ]
]
